/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT LIBRARY : STYLES --------------- ++++++++++ */
export default theme => ({
	library: {
		'& .page-details': {
			marginTop: pxToEm(40)
		},
		'&.processing-true': {
			'& .button:not(.processing-true)': { extend: disable },
			'& .link:not(.processing-true)': { extend: disable }
		}
	}
});
